const classes = { f: 'edit-boxy-outline', g: 'edit-boxy-fill' }

const EditBoxy = ({className}) => {
    return (
        <>
        <style>{'.edit-boxy-outline { fill: none; stroke: #888; stroke-miterlimit: 10; stroke-width: 1.5; } .edit-boxy-fill { fill: #888; }'}</style>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.13 20.22" className={className}><g id="a"/><g id="b"><g id="c"><path className={classes.f} d="M18.3,10.7v5.39c0,1.87-1.52,3.39-3.39,3.39H4.14c-1.87,0-3.39-1.52-3.39-3.39V5.31c0-1.87,1.52-3.39,3.39-3.39h5.39"/><path id="d" className={classes.g} d="M9.34,10.47h-.02L15.45,1.82l2.49,1.76-6.12,8.63h-.02l-3.05,1.71,.6-3.46Z"/><path id="e" className={classes.g} d="M17.64,.15l1.14,.81c.37,.26,.46,.78,.2,1.15l-.76,1.07h0l-2.49-1.76h0l.76-1.07c.26-.37,.78-.46,1.15-.2Z"/></g></g></svg>
        </>
    )
}

export default EditBoxy
